<template>
  <div class="d-flex flex-column pt-10">
    <h2 class="align-self-center mt-5">Step 2. Results</h2>
    <v-form @submit.prevent="submit" class="d-flex flex-column mt-12">
      <div class="d-flex">
        <div class="d-flex flex-grow-1 flex-column px-10">
          <p class="font-weight-bold">7. Test type</p>
          <v-select
            v-model="outcome.testType"
            label="Type of test"
            :items="[{text: 'Rapid test ', value: 'rapid'}, {text: 'RT-PCR', value: 'pcr'}]"
            item-text="text"
            class="staticWidth"
            item-value="value"
          ></v-select>
          <v-menu
            transition="scale-transition"
            offset-y
            v-if="outcome.testType=='rapid'"
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-on="on"
                class="staticWidth flex-grow-0"
                label="Date collected"
                readonly
                :error-messages="serumDateCollectedErrors"
                clearable
                v-model="serumDateCollectedFormat"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="specimentInformation.serumDateCollected"
              no-title
              color="primary"
            ></v-date-picker>
          </v-menu>

          <div class="d-flex flex-column" v-if="outcome.testType=='pcr'">
            <v-menu transition="scale-transition" offset-y max-width="290px" min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-on="on"
                  class="staticWidth flex-grow-0"
                  label="Date specimen collected"
                  readonly
                  :error-messages="swabDateCollectedErrors"
                  clearable
                  v-model="swabDateCollectedFormat"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="specimentInformation.swabDateCollected"
                no-title
                color="primary"
              ></v-date-picker>
            </v-menu>

            <!-- <v-text-field
              v-model="specimentInformation.swabDateCollected"
              label="Date Collected"
              class="staticWidth flex-grow-0"
              :error-messages="swabDateCollectedErrors"
            ></v-text-field>-->
            <v-menu transition="scale-transition" offset-y max-width="290px" min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-on="on"
                  class="staticWidth flex-grow-0"
                  label="Date specimen sent to laboratory"
                  readonly
                  :error-messages="swabDateSentToRitmErrors"
                  clearable
                  v-model="swabDateSentToRitmFormat"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="specimentInformation.swabDateSentToRitm"
                no-title
                color="primary"
              ></v-date-picker>
            </v-menu>

            <!-- <v-text-field
              v-model="specimentInformation.swabDateSentToRitm"
              label="Date Sent to RITM"
              class="staticWidth flex-grow-0"
              :error-messages="swabDateSentToRitmErrors"
            ></v-text-field>-->

            <v-menu transition="scale-transition" offset-y max-width="290px" min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-on="on"
                  class="staticWidth flex-grow-0"
                  label="Result release date"
                  readonly
                  :error-messages="swabDateReceivedInRitmErrors"
                  clearable
                  v-model="swabDateReceivedInRitmFormat"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="specimentInformation.swabDateReceivedInRitm"
                no-title
                color="primary"
              ></v-date-picker>
            </v-menu>

            <!-- <v-text-field
              v-model="specimentInformation.swabDateReceivedInRitm"
              label="Date received in RITM"
              hint="to be filled up by RITM"
              class="staticWidth flex-grow-0"
              :error-messages="swabDateReceivedInRitmErrors"
            ></v-text-field>-->
          </div>

          <!-- <v-checkbox label="Others" v-model="specimentInformation.others"></v-checkbox>
          <div class="d-flex flex-column ml-5" v-if="specimentInformation.others">
            <v-text-field
              v-model="specimentInformation.othersDateCollected"
              label="Date Collected(mm/dd/yyyy)"
              class="staticWidth flex-grow-0"
            ></v-text-field>
            <v-text-field
              v-model="specimentInformation.othersDateSentToRitm"
              label="Date Sent to RITM (mm/dd/yyyy)"
              class="staticWidth flex-grow-0"
            ></v-text-field>
            <v-text-field
              v-model="specimentInformation.othersDateReceivedInRitm"
              label="Date received in RITM"
              hint="to be filled up by RITM"
              class="staticWidth flex-grow-0"
            ></v-text-field>
            <v-text-field
              v-model="specimentInformation.othersVirusIsolationResult"
              label="Virus Isolation Result"
              class="staticWidth flex-grow-0"
            ></v-text-field>
            <v-text-field
              v-model="specimentInformation.othersPcrResult"
              label="PCR Result"
              class="staticWidth flex-grow-0"
            ></v-text-field>
          </div>-->

          <p class="font-weight-bold">8. Classification</p>
          <v-radio-group
            v-model="classification"
            class="staticWidth"
            label
            :error-messages="classificationErrors"
          >
            <v-radio
              value="CONFIRMED"
              :label="outcome.testType == 'rapid' ? 'Probable' : 'Confirmed positive'"
            ></v-radio>
            <v-radio
              value="NEGATIVE"
              :label="outcome.testType == 'rapid' ? 'Negative' : 'Confirmed negative'"
            ></v-radio>
          </v-radio-group>
        </div>
        <!-- 
        <div class="d-flex flex-grow-1 flex-column px-10">
          <p class="font-weight-bold">9. Outcome</p>

          <v-radio-group v-model="outcome.conditionOnDischarge" label="Condition on Discharge">
            <v-radio value="improved" label="Improved"></v-radio>
            <v-radio value="recovered" label="Recovered"></v-radio>
            <v-radio value="transferred" label="Trasferred"></v-radio>
            <v-radio value="abconded" label="Abconded"></v-radio>
            <v-radio value="died" label="Died"></v-radio>
          </v-radio-group>

          <v-text-field
            v-model="outcome.nameOfInformant"
            class="flex-grow-0 staticWidth"
            label="Name of Informant: (if patient not available)"
          ></v-text-field>
          <v-text-field
            v-model="outcome.relationship"
            class="flex-grow-0 staticWidth"
            label="Relationship"
          ></v-text-field>

          <v-text-field v-model="outcome.phoneNo" class="flex-grow-0 staticWidth" label="Phone No."></v-text-field>
        </div>-->
      </div>

      <v-btn
        color="primary"
        class="buttonText align-self-center my-10"
        width="200"
        rounded
        depressed
        type="submit"
      >Save & Proceed</v-btn>
    </v-form>

    <v-dialog v-model="reviewDialog" width="500">
      <v-card>
        <v-card-text>
          <div class="d-flex flex-column">
            <v-text-field
              class="ml-2 flex-grow-0"
              label="Test date *"
              v-if="!!$store.state.frontDesk.editingShippingTest.interviewDate"
              :value="interviewDateFormat"
              readonly
            ></v-text-field>
            <v-text-field
              class="ml-2 flex-grow-0"
              label="Company code *"
              readonly
              v-if="!!$store.state.frontDesk.editingShippingTest.orgCode"
              :value="$store.state.frontDesk.editingShippingTest.orgCode"
            ></v-text-field>
            <v-text-field
              class="flex-grow-0"
              label="First Name *"
              readonly
              v-if="!!$store.state.frontDesk.editingShippingTest.firstName"
              :value="$store.state.frontDesk.editingShippingTest.firstName"
            ></v-text-field>
            <v-text-field
              class="flex-grow-0"
              label="Last name *"
              readonly
              v-if="!!$store.state.frontDesk.editingShippingTest.lastName"
              :value="$store.state.frontDesk.editingShippingTest.lastName"
            ></v-text-field>

            <v-text-field
              class="flex-grow-0"
              label="Passport No. *"
              readonly
              :value="$store.state.frontDesk.editingShippingTest.passportNo"
              v-if="!!$store.state.frontDesk.editingShippingTest.passportNo"
            ></v-text-field>

            <v-text-field
              class="flex-grow-0"
              label="Cellphone No. *"
              readonly
              :value="$store.state.frontDesk.editingShippingTest.formJsonText.permanentAddress.cellPhoneNo"
              v-if="!!$store.state.frontDesk.editingShippingTest.formJsonText.permanentAddress.cellPhoneNo"
            ></v-text-field>
            <v-text-field
              class="flex-grow-0"
              label="Email Address *"
              readonly
              :value="$store.state.frontDesk.editingShippingTest.email"
              v-if="!!$store.state.frontDesk.editingShippingTest.email"
            ></v-text-field>
            <v-text-field
              class="flex-grow-0"
              label="Full Address *"
              readonly
              :value="$store.state.frontDesk.editingShippingTest.formJsonText.fullAddress"
              v-if="!!$store.state.frontDesk.editingShippingTest.formJsonText.fullAddress"
            ></v-text-field>

            <p class="font-weight-bold">1. Patient Profile</p>

            <v-text-field
              class="flex-grow-0"
              label="Middle Name"
              readonly
              v-if="!!$store.state.frontDesk.editingShippingTest.formJsonText.patientProfile.middleName"
              :value="$store.state.frontDesk.editingShippingTest.formJsonText.patientProfile.middleName"
            ></v-text-field>
            <v-text-field
              class="flex-grow-0"
              label="BirthDay"
              readonly
              v-if="!!$store.state.frontDesk.editingShippingTest.formJsonText.patientProfile.birthDay"
              :value="$store.state.frontDesk.editingShippingTest.formJsonText.patientProfile.birthDay"
            ></v-text-field>

            <v-text-field
              class="flex-grow-0"
              readonly
              label="Age"
              :value="$store.state.frontDesk.editingShippingTest.formJsonText.patientProfile.age"
              v-if="!!$store.state.frontDesk.editingShippingTest.formJsonText.patientProfile.age"
            ></v-text-field>

            <v-text-field
              class="flex-grow-0"
              readonly
              label="Sex"
              :value="$store.state.frontDesk.editingShippingTest.formJsonText.patientProfile.sex"
              v-if="!!$store.state.frontDesk.editingShippingTest.formJsonText.patientProfile.sex"
            ></v-text-field>
            <v-text-field
              class="flex-grow-0"
              label="Occupation"
              readonly
              :value="$store.state.frontDesk.editingShippingTest.formJsonText.patientProfile.occupation"
              v-if="!!$store.state.frontDesk.editingShippingTest.formJsonText.patientProfile.occupation"
            ></v-text-field>
            <v-text-field
              class="flex-grow-0"
              label="Civil Status"
              readonly
              :value="$store.state.frontDesk.editingShippingTest.formJsonText.patientProfile.civilStatus"
              v-if="!!$store.state.frontDesk.editingShippingTest.formJsonText.patientProfile.civilStatus"
            ></v-text-field>
            <v-text-field
              class="flex-grow-0"
              label="Nationality"
              readonly
              :value="$store.state.frontDesk.editingShippingTest.formJsonText.patientProfile.nationality"
              v-if="!!$store.state.frontDesk.editingShippingTest.formJsonText.patientProfile.nationality"
            ></v-text-field>

            <p class="font-weight-bold">2. Phillipine Residence</p>
            <p class="font-weight-bold">2.1 Permanent Address</p>
            <v-text-field
              class="flex-grow-0"
              label="House No./Lot/Bldg"
              readonly
              :value="$store.state.frontDesk.editingShippingTest.formJsonText.permanentAddress.houseNo"
              v-if="!!$store.state.frontDesk.editingShippingTest.formJsonText.permanentAddress.houseNo"
            ></v-text-field>
            <v-text-field
              class="flex-grow-0"
              label="Street/Barangay"
              readonly
              :value="$store.state.frontDesk.editingShippingTest.formJsonText.permanentAddress.street"
              v-if="!!$store.state.frontDesk.editingShippingTest.formJsonText.permanentAddress.street"
            ></v-text-field>
            <v-text-field
              class="flex-grow-0"
              label="Municipality"
              readonly
              :value="$store.state.frontDesk.editingShippingTest.formJsonText.permanentAddress.municipality"
              v-if="!!$store.state.frontDesk.editingShippingTest.formJsonText.permanentAddress.municipality"
            ></v-text-field>
            <v-text-field
              class="flex-grow-0"
              label="City"
              :value="$store.state.frontDesk.editingShippingTest.formJsonText.permanentAddress.city"
              v-if="!!$store.state.frontDesk.editingShippingTest.formJsonText.permanentAddress.city"
            ></v-text-field>
            <v-text-field
              class="flex-grow-0"
              label="Province"
              :value="$store.state.frontDesk.editingShippingTest.formJsonText.permanentAddress.province"
              v-if="!!$store.state.frontDesk.editingShippingTest.formJsonText.permanentAddress.province"
            ></v-text-field>
            <v-text-field
              class="flex-grow-0"
              label="Region"
              :value="$store.state.frontDesk.editingShippingTest.formJsonText.permanentAddress.region"
              v-if="!!$store.state.frontDesk.editingShippingTest.formJsonText.permanentAddress.region"
            ></v-text-field>
            <v-text-field
              class="flex-grow-0"
              readonly
              label="Home Phone No."
              :value="$store.state.frontDesk.editingShippingTest.formJsonText.permanentAddress.homePhoneNo"
              v-if="!!$store.state.frontDesk.editingShippingTest.formJsonText.permanentAddress.homePhoneNo"
            ></v-text-field>

            <p class="font-weight-bold">2.2 Current Address</p>
            <v-text-field
              class="flex-grow-0"
              readonly
              label="House No./Lot/Bldg"
              :value="$store.state.frontDesk.editingShippingTest.formJsonText.currentAddress.houseNo"
              v-if="!!$store.state.frontDesk.editingShippingTest.formJsonText.currentAddress.houseNo"
            ></v-text-field>
            <v-text-field
              class="flex-grow-0"
              readonly
              label="Street/Barangay"
              :value="$store.state.frontDesk.editingShippingTest.formJsonText.currentAddress.street"
              v-if="!!$store.state.frontDesk.editingShippingTest.formJsonText.currentAddress.street"
            ></v-text-field>
            <v-text-field
              class="flex-grow-0"
              readonly
              label="Municipality"
              :value="$store.state.frontDesk.editingShippingTest.formJsonText.currentAddress.municipality"
              v-if="!!$store.state.frontDesk.editingShippingTest.formJsonText.currentAddress.municipality"
            ></v-text-field>
            <v-text-field
              class="flex-grow-0"
              readonly
              label="City"
              :value="$store.state.frontDesk.editingShippingTest.formJsonText.currentAddress.city"
              v-if="!!$store.state.frontDesk.editingShippingTest.formJsonText.currentAddress.city"
            ></v-text-field>
            <v-text-field
              class="flex-grow-0"
              readonly
              label="Province"
              :value="$store.state.frontDesk.editingShippingTest.formJsonText.currentAddress.province"
              v-if="!!$store.state.frontDesk.editingShippingTest.formJsonText.currentAddress.province"
            ></v-text-field>
            <v-text-field
              class="flex-grow-0"
              readonly
              label="Region"
              :value="$store.state.frontDesk.editingShippingTest.formJsonText.currentAddress.region"
              v-if="!!$store.state.frontDesk.editingShippingTest.formJsonText.currentAddress.region"
            ></v-text-field>
            <v-text-field
              class="flex-grow-0"
              label="Home Phone No."
              readonly
              :value="$store.state.frontDesk.editingShippingTest.formJsonText.currentAddress.homePhoneNo"
              v-if="!!$store.state.frontDesk.editingShippingTest.formJsonText.currentAddress.homePhoneNo"
            ></v-text-field>
            <v-text-field
              class="flex-grow-0"
              readonly
              label="Work Phone No."
              :value="$store.state.frontDesk.editingShippingTest.formJsonText.currentAddress.workPhoneNo"
              v-if="!!$store.state.frontDesk.editingShippingTest.formJsonText.currentAddress.workPhoneNo"
            ></v-text-field>
            <v-text-field
              class="flex-grow-0"
              readonly
              label="Other Email Address"
              :value="$store.state.frontDesk.editingShippingTest.formJsonText.currentAddress.otherEmail"
              v-if="!!$store.state.frontDesk.editingShippingTest.formJsonText.currentAddress.otherEmail"
            ></v-text-field>

            <p class="font-weight-bold">3. Address Outside the Philipines</p>

            <v-text-field
              class="flex-grow-0"
              label="Employer's Name"
              :value="$store.state.frontDesk.editingShippingTest.formJsonText.addressOutside.employersName"
              v-if="!!$store.state.frontDesk.editingShippingTest.formJsonText.addressOutside.employersName"
              readonly
            ></v-text-field>
            <v-text-field
              class="flex-grow-0"
              label="Occcupation"
              :value="$store.state.frontDesk.editingShippingTest.formJsonText.addressOutside.occupation"
              v-if="!!$store.state.frontDesk.editingShippingTest.formJsonText.addressOutside.occupation"
              readonly
            ></v-text-field>
            <v-text-field
              class="flex-grow-0"
              label="Place of Work"
              :value="$store.state.frontDesk.editingShippingTest.formJsonText.addressOutside.placeOfWork"
              v-if="!!$store.state.frontDesk.editingShippingTest.formJsonText.addressOutside.placeOfWork"
              readonly
            ></v-text-field>
            <v-text-field
              class="flex-grow-0"
              label="House No./Bldg Name"
              :value="$store.state.frontDesk.editingShippingTest.formJsonText.addressOutside.houseNo"
              v-if="!!$store.state.frontDesk.editingShippingTest.formJsonText.addressOutside.houseNo"
              readonly
            ></v-text-field>
            <v-text-field
              class="flex-grow-0"
              label="Street"
              :value="$store.state.frontDesk.editingShippingTest.formJsonText.addressOutside.street"
              v-if="!!$store.state.frontDesk.editingShippingTest.formJsonText.addressOutside.street"
              readonly
            ></v-text-field>
            <v-text-field
              class="flex-grow-0"
              label="Municipality"
              :value="$store.state.frontDesk.editingShippingTest.formJsonText.addressOutside.municipality"
              v-if="!!$store.state.frontDesk.editingShippingTest.formJsonText.addressOutside.municipality"
              readonly
            ></v-text-field>
            <v-text-field
              class="flex-grow-0"
              label="City"
              :value="$store.state.frontDesk.editingShippingTest.formJsonText.addressOutside.city"
              v-if="!!$store.state.frontDesk.editingShippingTest.formJsonText.addressOutside.city"
              readonly
            ></v-text-field>
            <v-text-field
              class="flex-grow-0"
              label="Province"
              :value="$store.state.frontDesk.editingShippingTest.formJsonText.addressOutside.province"
              v-if="!!$store.state.frontDesk.editingShippingTest.formJsonText.addressOutside.province"
              readonly
            ></v-text-field>
            <v-text-field
              class="flex-grow-0"
              label="Country"
              :value="$store.state.frontDesk.editingShippingTest.formJsonText.addressOutside.country"
              v-if="!!$store.state.frontDesk.editingShippingTest.formJsonText.addressOutside.country"
              readonly
            ></v-text-field>
            <v-text-field
              class="flex-grow-0"
              label="Office Phone No"
              :value="$store.state.frontDesk.editingShippingTest.formJsonText.addressOutside.officePhoneNo"
              v-if="!!$store.state.frontDesk.editingShippingTest.formJsonText.addressOutside.officePhoneNo"
              readonly
            ></v-text-field>
            <v-text-field
              class="flex-grow-0"
              label="Cellphone No"
              :value="$store.state.frontDesk.editingShippingTest.formJsonText.addressOutside.cellPhoneNo"
              v-if="!!$store.state.frontDesk.editingShippingTest.formJsonText.addressOutside.cellPhoneNo"
              readonly
            ></v-text-field>

            <p class="font-weight-bold">7. Test type</p>
            <v-select
              :value="outcome.testType"
              readonly
              v-if="!!outcome.testType"
              label="Type of test"
              :items="[{text: 'Rapid test ', value: 'rapid'}, {text: 'RT-PCR', value: 'pcr'}]"
              item-text="text"
              class="staticWidth"
              item-value="value"
            ></v-select>
            <v-menu
              transition="scale-transition"
              offset-y
              v-if="outcome.testType=='rapid'"
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-on="on"
                  class="staticWidth flex-grow-0"
                  label="Date collected"
                  readonly
                  disabled
                  :error-messages="serumDateCollectedErrors"
                  clearable
                  v-model="serumDateCollectedFormat"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="specimentInformation.serumDateCollected"
                no-title
                color="primary"
              ></v-date-picker>
            </v-menu>

            <div class="d-flex flex-column" v-if="outcome.testType=='pcr'">
              <v-menu transition="scale-transition" offset-y max-width="290px" min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    class="staticWidth flex-grow-0"
                    label="Date specimen collected"
                    readonly
                    disabled
                    :error-messages="swabDateCollectedErrors"
                    clearable
                    v-model="swabDateCollectedFormat"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="specimentInformation.swabDateCollected"
                  no-title
                  color="primary"
                ></v-date-picker>
              </v-menu>

              <v-menu transition="scale-transition" offset-y max-width="290px" min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    class="staticWidth flex-grow-0"
                    label="Date specimen sent to laboratory"
                    readonly
                    disabled
                    :error-messages="swabDateSentToRitmErrors"
                    clearable
                    v-model="swabDateSentToRitmFormat"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="specimentInformation.swabDateSentToRitm"
                  no-title
                  color="primary"
                ></v-date-picker>
              </v-menu>

              <v-menu transition="scale-transition" offset-y max-width="290px" min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    class="staticWidth flex-grow-0"
                    label="Result release date"
                    readonly
                    disabled
                    :error-messages="swabDateReceivedInRitmErrors"
                    clearable
                    v-model="swabDateReceivedInRitmFormat"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="specimentInformation.swabDateSentToRitm"
                  no-title
                  color="primary"
                ></v-date-picker>
              </v-menu>
            </div>

            <p class="font-weight-bold">8. Classification</p>
            <v-radio-group
              v-model="classification"
              class="staticWidth"
              label
              disabled
              :error-messages="classificationErrors"
            >
              <v-radio
                value="CONFIRMED"
                :label="outcome.testType == 'rapid' ? 'Probable' : 'Confirmed positive'"
              ></v-radio>
              <v-radio
                value="NEGATIVE"
                :label="outcome.testType == 'rapid' ? 'Negative' : 'Confirmed negative'"
              ></v-radio>
            </v-radio-group>

           <div class="d-flex align-center justify-center">

             <v-btn color="gray" class="buttonText" rounded depressed width="150" @click="reviewDialog=false">Cancel</v-btn>
              <v-btn
              color="primary"
              class="buttonText ml-2"
              rounded
              depressed
              width="150"
              @click="post"
            >Submit</v-btn>
           </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { required, requiredIf } from "vuelidate/lib/validators";
import moment from "moment";
export default {
  data() {
    return {
      reviewDialog: false,
      reportType: "shipping",
      specimentInformation: {
        serum: this.$store.state.frontDesk.editingShippingTest?.formJsonText
          ?.specimentInformation?.serum,
        serumDateCollected: this.$store.state.frontDesk.editingShippingTest
          ?.formJsonText?.specimentInformation?.serumDateCollected,
        serumDateSentToRitm: this.$store.state.frontDesk.editingShippingTest
          ?.formJsonText?.specimentInformation?.serumDateSentToRitm,
        serumDateReceivedInRitm: this.$store.state.frontDesk.editingShippingTest
          ?.formJsonText?.specimentInformation?.serumDateReceivedInRitm,
        serumVirusIsolationResult: this.$store.state.frontDesk.editingShippingTest
          ?.formJsonText?.specimentInformation?.serumVirusIsolationResult,
        serumPcrResult: this.$store.state.frontDesk.editingShippingTest
          ?.formJsonText?.specimentInformation?.serumPcrResult,

        swab: this.$store.state.frontDesk.editingShippingTest?.formJsonText
          ?.specimentInformation?.swab,
        swabDateCollected: this.$store.state.frontDesk.editingShippingTest
          ?.formJsonText?.specimentInformation?.swabDateCollected,
        swabDateSentToRitm: this.$store.state.frontDesk.editingShippingTest
          ?.formJsonText?.specimentInformation?.swabDateSentToRitm,
        swabDateReceivedInRitm: this.$store.state.frontDesk.editingShippingTest
          ?.formJsonText?.specimentInformation?.swabDateReceivedInRitm,
        swabVirusIsolationResult: this.$store.state.frontDesk.editingShippingTest
          ?.formJsonText?.specimentInformation?.swabVirusIsolationResult,
        swabPcrResult: this.$store.state.frontDesk.editingShippingTest?.formJsonText
          ?.specimentInformation?.swabPcrResult,

        others: this.$store.state.frontDesk.editingShippingTest?.formJsonText
          ?.specimentInformation?.others,
        othersDateCollected: this.$store.state.frontDesk.editingShippingTest
          ?.formJsonText?.specimentInformation?.othersDateCollected,
        othersDateSentToRitm: this.$store.state.frontDesk.editingShippingTest
          ?.formJsonText?.specimentInformation?.othersDateSentToRitm,
        othersDateReceivedInRitm: this.$store.state.frontDesk.editingShippingTest
          ?.formJsonText?.specimentInformation?.othersDateReceivedInRitm,
        othersVirusIsolationResult: this.$store.state.frontDesk.editingShippingTest
          ?.formJsonText?.specimentInformation?.othersVirusIsolationResult,
        othersPcrResult: this.$store.state.frontDesk.editingShippingTest
          ?.formJsonText?.specimentInformation?.othersPcrResult,
      },

      classification: this.$store.state.frontDesk.editingShippingTest?.formJsonText
        ?.classification,

      outcome: {
        conditionOnDischarge: this.$store.state.frontDesk.editingShippingTest
          ?.formJsonText?.outcome?.conditionOnDischarge,
        nameOfInformant: this.$store.state.frontDesk.editingShippingTest
          ?.formJsonText?.outcome?.nameOfInformant,
        relationship: this.$store.state.frontDesk.editingShippingTest?.formJsonText
          ?.outcome?.relationship,
        phoneNo: this.$store.state.frontDesk.editingShippingTest?.formJsonText
          ?.outcome?.phoneNo,
        testType: this.$store.state.frontDesk.editingShippingTest?.formJsonText
          ?.outcome?.testType,
      },
    };
  },

  methods: {
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.reviewDialog = true;
      }
    },

    post() {
      const credentials = {
        reportType: this.reportType,
        specimentInformation: this.specimentInformation,
        classification: this.classification,
        outcome: this.outcome,
      };

      this.$store.dispatch("editShippingTestThird", credentials);

      this.reviewDialog = false;
    },
  },

  validations: {
    classification: { required },
    specimentInformation: {
      serumDateCollected: {
        required: requiredIf(function () {
          return this.computedTestType == "rapid";
        }),
      },
      swabDateCollected: {
        required: requiredIf(function () {
          return this.computedTestType == "pcr";
        }),
      },
      swabDateSentToRitm: {
        required: requiredIf(function () {
          return this.computedTestType == "pcr";
        }),
      },
      swabDateReceivedInRitm: {
        required: requiredIf(function () {
          return this.computedTestType == "pcr";
        }),
      },
    },
  },

  computed: {
    interviewDateFormat(){
      return this.$store.state.frontDesk.editingShippingTest.interviewDate
    },
    computedTestType() {
      return this.outcome.testType;
    },
    serumDateCollectedFormat: {
      set() {
        this.specimentInformation.serumDateCollected = null;
      },
      get() {
        if (this.specimentInformation.serumDateCollected == null) {
          return "";
        }
        return moment(this.specimentInformation.serumDateCollected).format(
          "DD/MM/YYYY"
        );
      },
    },
    swabDateCollectedFormat: {
      set() {
        this.specimentInformation.swabDateCollected = null;
      },
      get() {
        if (this.specimentInformation.swabDateCollected == null) {
          return "";
        }
        return moment(this.specimentInformation.swabDateCollected).format(
          "DD/MM/YYYY"
        );
      },
    },
    swabDateSentToRitmFormat: {
      set() {
        this.specimentInformation.swabDateSentToRitm = null;
      },
      get() {
        if (this.specimentInformation.swabDateSentToRitm == null) {
          return "";
        }
        return moment(this.specimentInformation.swabDateSentToRitm).format(
          "DD/MM/YYYY"
        );
      },
    },
    swabDateReceivedInRitmFormat: {
      set() {
        this.specimentInformation.swabDateReceivedInRitm = null;
      },
      get() {
        if (this.specimentInformation.swabDateReceivedInRitm == null) {
          return "";
        }
        return moment(this.specimentInformation.swabDateReceivedInRitm).format(
          "DD/MM/YYYY"
        );
      },
    },

    classificationErrors() {
      const error = [];
      if (!this.$v.classification.$dirty) return error;
      if (!this.$v.classification.required) error.push("Required");
      return error;
    },
    serumDateCollectedErrors() {
      const error = [];
      if (!this.$v.specimentInformation.serumDateCollected.$dirty) return error;
      if (!this.$v.specimentInformation.serumDateCollected.required)
        error.push("Required");
      return error;
    },
    swabDateCollectedErrors() {
      const error = [];
      if (!this.$v.specimentInformation.swabDateCollected.$dirty) return error;
      if (!this.$v.specimentInformation.swabDateCollected.required)
        error.push("Required");
      return error;
    },
    swabDateSentToRitmErrors() {
      const error = [];
      if (!this.$v.specimentInformation.swabDateSentToRitm.$dirty) return error;
      if (!this.$v.specimentInformation.swabDateSentToRitm.required)
        error.push("Required");
      return error;
    },
    swabDateReceivedInRitmErrors() {
      const error = [];
      if (!this.$v.specimentInformation.swabDateReceivedInRitm.$dirty)
        return error;
      if (!this.$v.specimentInformation.swabDateReceivedInRitm.required)
        error.push("Required");
      return error;
    },
  },
};
</script>

<style lang="scss" scoped>
.staticWidth {
  width: 400px;
}
</style>